// Backend HTTP status codes we handle explicitly in the UI.
export const HTTP_PAYMENT_REQUIRED = 402;
export const HTTP_RATE_LIMITED = 429;
